import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import CopyButton from '#client/components/CopyButton';

export default function MenuItemRow({ copyText, title, texts, callback = () => {} }) {
  return (
    <Stack
      gap="10px"
      py="8px"
    >
      <Text
        color="secondary"
        size="xs"
        weight="medium"
      >
        {title}
      </Text>
      <Stack
        alignItems="center"
        direction="row"
        gap="8px"
      >
        <Stack gap="2px">
          {texts.map((text, index) => (
            <Text
              color="primary"
              component="p"
              // eslint-disable-next-line react/no-array-index-key
              key={`${title}-${index}`}
              size="md"
              sx={{
                width: text ? 'auto' : '200px'
              }}
              weight="medium"
            >
              {text || <Skeleton width="100%" />}
            </Text>
          ))}
        </Stack>
        {copyText && (
          <CopyButton
            arrow
            callback={callback}
            copyText={copyText}
            placement="top"
          />
        )}
      </Stack>
    </Stack>
  );
}

MenuItemRow.propTypes = {
  copyText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  texts: PropTypes.arrayOf(PropTypes.string).isRequired,
  callback: PropTypes.func
};
